import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { EquipmentActivityService } from '../_services';
import * as EquipmentActivityActions from '../_actions/equipmentActivity';

@Injectable({
  providedIn: 'root',
})
export class EquipmentActivityEffects {
  loadEquipmentActivities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EquipmentActivityActions.loadEquipmentActivities),
      mergeMap(() =>
        this.equipmentActivityService.getEquipmentActivities().pipe(
          map((equipmentActivities) =>
            EquipmentActivityActions.loadEquipmentActivitiesSuccess({ equipmentActivities })
          ),
          catchError((error) =>
            of(EquipmentActivityActions.loadEquipmentActivitiesFailure({ error }))
          )
        )
      )
    )
  );

  addEquipmentActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EquipmentActivityActions.addEquipmentActivity),
      mergeMap(({ equipmentActivity }) =>
        this.equipmentActivityService.saveEquipmentActivity(equipmentActivity).pipe(
          map((savedEquipmentActivity) =>
            EquipmentActivityActions.addEquipmentActivitySuccess({
              equipmentActivity: savedEquipmentActivity,
            })
          ),
          catchError((error) => of(EquipmentActivityActions.addEquipmentActivityFailure({ error })))
        )
      )
    )
  );

  updateEquipmentActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EquipmentActivityActions.updateEquipmentActivity),
      mergeMap(({ equipmentActivity }) =>
        this.equipmentActivityService.saveEquipmentActivity(equipmentActivity).pipe(
          map((updatedEquipmentActivity) =>
            EquipmentActivityActions.updateEquipmentActivitySuccess({
              equipmentActivity: updatedEquipmentActivity,
            })
          ),
          catchError((error) =>
            of(EquipmentActivityActions.updateEquipmentActivityFailure({ error }))
          )
        )
      )
    )
  );

  deleteEquipmentActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EquipmentActivityActions.deleteEquipmentActivity),
      mergeMap(({ id }) =>
        this.equipmentActivityService.deleteEquipmentActivity(id).pipe(
          map(() => EquipmentActivityActions.deleteEquipmentActivitySuccess({ id })),
          catchError((error) =>
            of(EquipmentActivityActions.deleteEquipmentActivityFailure({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private equipmentActivityService: EquipmentActivityService
  ) {}
}
